module.exports = __webpack_public_path__ + "static/media/stalkx_blurred.66894ac2.jpg";